import type {
  MeetingEvidenceState,
  MeetingUnknownReason,
} from '@/types/meeting-center'

export interface MeetingUnknownReasonPresentation {
  state: MeetingEvidenceState
  label: string
}

/**
 * API の内部 reason code を UI 表示へ変換する唯一の正本。
 * code 自体は画面へ描画しない。
 */
export const MEETING_UNKNOWN_REASON_PRESENTATION: Readonly<
  Record<MeetingUnknownReason, MeetingUnknownReasonPresentation>
> = {
  baseline_unavailable: {
    state: 'unknown',
    label: '比較対象となる前週データを確認できません',
  },
  evidence_unavailable: {
    state: 'unknown',
    label: '確認に必要な根拠を利用できません',
  },
  source_error: {
    state: 'error',
    label: '情報源の取得に失敗しています',
  },
  source_stale: {
    state: 'stale',
    label: '情報源の更新期限を超えています',
  },
  not_configured: {
    state: 'not_configured',
    label: '必要な情報源が未設定です',
  },
  access_denied: {
    state: 'denied',
    label: '情報源は権限により非表示です',
  },
  conflict: {
    state: 'conflict',
    label: '複数の根拠が一致していません',
  },
  needs_review: {
    state: 'unknown',
    label: '内容の確認が必要です',
  },
}

export function meetingUnknownReasonPresentation(
  reason: MeetingUnknownReason,
): MeetingUnknownReasonPresentation {
  return MEETING_UNKNOWN_REASON_PRESENTATION[reason]
}
